import axios from 'axios'

const baseURL = 'http://www.localhost:8080/'
const axiosInstance = axios.create({
  baseURL,
  headers: { axiosRequest: true },
})

axiosInstance.interceptors.response.use(
  (response) => ({ ...response, response: response.data }),
  (error) => Promise.reject(error),
)

export default axiosInstance
